import Vue from 'vue';
import moment from 'moment-timezone';

import state from '../state';

Vue.filter('datetime', function(date, showFull) {
    if (!date) return '';
    var mdate = moment.tz(date, state.adminTimezone.get().id);

    if (showFull) return mdate.format('D MMM YYYY HH:mm:ss');

    if (mdate.isSame(new Date(), 'day')) {
        return mdate.format('HH:mm:ss');
    } else if (mdate.isSame(new Date(), 'year')) {
        return mdate.format('D MMM HH:mm:ss');
    }
    return mdate.format('D MMM YYYY HH:mm:ss');
});



// WEBPACK FOOTER //
// ./src/filters/datetime.filter.js